// extracted by mini-css-extract-plugin
export var formcontact = "formcontact-module--formcontact--1sqdP";
export var contactflex = "formcontact-module--contactflex--3BIlI";
export var buttomsubmit = "formcontact-module--buttomsubmit--3xDuo";